<template>
  <modal
    ref="modal"
    title="Editar dados"
    @close="closeModalEdit"
    :showModal="hasModalCompanyEdit"
  >
    <template v-slot:body>
      <ValidationObserver
        tag="div"
        class="body"
        ref="form"
        v-slot="{ passes, pristine }"
      >
        <form @input="toggleButtonState(pristine)" @submit.prevent="passes(submitCompanyFormData)">
          <div class="container">
            <div class="section">
              <div class="column">
                <input-field
                  placeholder="E-mail"
                  name="email"
                  rules="required|mail"
                  v-model="companyData.email"
                />
              </div>

              <div class="two-column">
                <input-field
                  placeholder="Nome fantasia"
                  name="statementDescriptor"
                  rules="required"
                  v-model="companyData.statementDescriptor"
                />

                <input-field
                  class="right"
                  placeholder="Telefone"
                  name="phone"
                   :mask="['(##) ####-####', '(##) #####-####']"
                  rules="required"
                  v-model="companyData.businessPhoneNumber"
                />
              </div>
            </div>

            <div class="button-container">
              <button-component
                scale="normal"
                size="large"
                v-ripple="'rgba(255, 139, 0, 0.2)'"
                styles="ghost"
                type="button"
                @click.native="closeModalEdit"
                text="Fechar"
              />

              <button-component
                class="right"
                scale="normal"
                size="large"
                v-ripple="'rgba(255, 255, 255, 0.35)'"
                styles="primary"
                :isDisabled="isButtonDisable"
                :hasLoader="hasRequest"
                text="Alterar e salvar"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </template>
  </modal>
</template>

<script>
  import { ValidationObserver } from 'vee-validate';
  import { mapState } from 'vuex';
  import Modal from '@/components/Modal';
  import Button from '@/components/Button';
  import InputField from '@/components/InputField';

  export default {
    name: 'ModalEditAutonomousSeller',

    data() {
      return {
        hasRequest: false,
        isButtonDisable: true,
        companyData: {
          email: '',
          statementDescriptor: '',
          businessphoneNumber: '',
          businessAddressLine: '',
          businessAddressNumber: '',
          businessAddressComplement: '',
          businessAddressNeighborhood: '',
          businessAddressCity: '',
          businessAddressState: '',
          businessAddressPostalCode: '',
          ownerAddressLine: '',
          ownerAddressNumber: '',
          ownerAddressComplement: '',
          ownerAddressNeighborhood: '',
          ownerAddressCity: '',
          ownerAddressState: '',
          ownerAddressPostalCode: '',
        },
      };
    },

    components: {
      ValidationObserver,
      'button-component': Button,
      'input-field': InputField,
      'modal': Modal
    },

    computed: {
      ...mapState({
        hasModalCompanyEdit: state => state.hasModalCompanyEdit,
        sellerData: state => state.sellerData,
      })
    },

    watch: {
      sellerData() {
        this.setDefaultCompanyValues();
      },

      hasModalCompanyEdit() {
        this.setDefaultCompanyValues();
      }
    },

    mounted() {
      this.setDefaultCompanyValues();
    },

    methods: {
      submitCompanyFormData() {
        this.hasRequest = true;

        let formData = JSON.stringify({
          business_email: this.companyData.email,
          statement_descriptor: this.companyData.statementDescriptor,

          business_phone_number: this.$service.removeCharacter(this.companyData.businessPhoneNumber),
          business_address_line1: this.companyData.businessAddressLine,
          business_address_line2: this.companyData.businessAddressNumber,
          business_address_line3: this.companyData.businessAddressComplement,
          business_address_neighborhood: this.companyData.businessAddressNeighborhood,
          business_address_city: this.companyData.businessAddressCity,
          business_address_state: this.companyData.businessAddressState,
          business_address_postal_code: this.$service.removeCharacter(this.companyData.businessAddressPostalCode),

          owner_address_line1: this.companyData.ownerAddressLine,
          owner_address_line2: this.companyData.ownerAddressNumber,
          owner_address_line3: this.companyData.ownerAddressComplement,
          owner_address_neighborhood: this.companyData.ownerAddressNeighborhood,
          owner_address_city: this.companyData.ownerAddressCity,
          owner_address_state: this.companyData.ownerAddressState,
          owner_address_postal_code: this.$service.removeCharacter(this.companyData.ownerAddressPostalCode),
        });

        this.$store.dispatch('putCompanySeller', { formData })
          .then(() => {
            this.$store.dispatch('fetchSellerData')
              .then(() => {
                this.setSuccessAlertCard();
                this.$store.commit('setAlertCardStatus', true);
              })
              .catch(() => {
                this.setUpdateErrorAlertCard();
                this.$store.commit('setAlertCardStatus', true);
              })
              .finally(() => {
                this.closeModalEdit();
                this.hasRequest = false;
              });
          })
          .catch(() => {
            this.closeModalEdit();
            this.hasRequest = false;
            this.$store.commit('setAlertCardStatus', true);
            this.setErrorAlertCard();
          });

        this.isButtonDisable = true;
      },

      setDefaultCompanyValues() {
        this.companyData.email = this.sellerData.business_email;
        this.companyData.statementDescriptor = this.sellerData.statement_descriptor;

        this.companyData.businessPhoneNumber = this.sellerData.business_phone;
        this.companyData.businessAddressLine = this.sellerData.business_address_line1;
        this.companyData.businessAddressNumber = this.sellerData.business_address_line2;
        this.companyData.businessAddressComplement = this.sellerData.business_address_line3;
        this.companyData.businessAddressNeighborhood = this.sellerData.business_address_neighborhood;
        this.companyData.businessAddressCity = this.sellerData.business_address_city;
        this.companyData.businessAddressState = this.sellerData.business_address_state;
        this.companyData.businessAddressPostalCode = this.sellerData.business_address_postal_code;

        this.companyData.ownerAddressLine = this.sellerData.owner_address_line1;
        this.companyData.ownerAddressNumber = this.sellerData.owner_address_line2;
        this.companyData.ownerAddressComplement = this.sellerData.owner_address_line3;
        this.companyData.ownerAddressNeighborhood = this.sellerData.owner_address_neighborhood;
        this.companyData.ownerAddressCity = this.sellerData.owner_address_city;
        this.companyData.ownerAddressState = this.sellerData.owner_address_state;
        this.companyData.ownerAddressPostalCode = this.sellerData.owner_address_postal_code;
      },

      closeModalEdit() {
        this.$store.commit('closeModalEdit');
      },

      setSuccessAlertCard() {
        this.$store.commit('setAlertCardData', {
          text: 'Dados editados com sucesso.',
          color: '#08B978'
        });
      },

      setErrorAlertCard() {
        this.$store.commit('setAlertCardData', {
          text: 'Erro ao editar os dados cadastrais.',
          color: '#FF5A5A'
        });
      },

      setUpdateErrorAlertCard() {
        this.$store.commit('setAlertCardData', {
          text: 'Erro ao atualizar os dados.',
          color: '#FF5A5A'
        });
      },

      toggleButtonState(pristine) {
        this.isButtonDisable = pristine;

        if (this.hasRequest) {
          this.isButtonDisable = true;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .modal {
    .body {
      .container {
        margin-top: 1.5rem;

        .section {
          .two-column {
            display: flex;

            .right {
              margin-left: 1rem;
              max-width: 225px;
            }
          }

          .column {
            max-width: 305px;
          }
        }
      }
    }

    .button-container {
      display: flex;
      justify-content: flex-end;

      .right {
        margin-left: 1rem;
        min-width: 156px;
      }
    }
  }

  @media (max-width: 767px) {
    .modal {
      h2 {
        font-size: 16px;
      }
    }
  }


  @media (max-width: 520px) {
    .modal {
      .body {
        .container {
          overflow-y: scroll;
          max-height: 72vh;
          margin-bottom: 4rem;

          &::-webkit-scrollbar {
            display: none;
          }

          .section {
            .two-column {
              flex-direction: column;

              .right {
                margin-left: 0;
                max-width: initial;
              }
            }

            .column {
              width: 100%;
              max-width: unset;
            }
          }

          .button-container {
            justify-content: center;
          }
        }
      }
    }
  }
</style>